import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';
import type { ProcessStep } from '../types';

interface ProcessSectionProps {
  steps: ProcessStep[];
}

const ProcessSection = ({ steps }: ProcessSectionProps) => {
  const handleTestClick = () => {
    window.open('https://t.me/Aidating_love7_bot?start=004_res', '_blank');
  };

  return (
    <section id="how-it-works" className="relative py-20 sm:py-32 bg-gradient-to-b from-background to-primary/5 overflow-hidden">
      {/* Festive decorative elements */}
      <div className="absolute inset-0 overflow-hidden pointer-events-none">
        <div className="absolute top-10 right-10 text-pink-300/10 animate-float">
          <Icon name="Heart" size={64} />
        </div>
        <div className="absolute bottom-20 left-10 text-red-300/10 animate-float-delay">
          <Icon name="Sparkles" size={56} />
        </div>
      </div>

      <div className="relative max-w-content mx-auto px-4 sm:px-6">
        <div className="text-center mb-16">
          <div className="inline-flex items-center gap-2 px-4 py-2 bg-accent/10 rounded-full text-accent text-sm font-medium mb-4">
            <Icon name="Brain" size={16} />
            <span>Полная автоматизация поиска</span>
          </div>
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-foreground mb-4">
            Как работает цифровой двойник
          </h2>
          <p className="text-lg text-secondary max-w-2xl mx-auto">
            Пройдите бесплатное тестирование 7 каналов мышления и создайте цифровой двойник для автоматического поиска наилучшей пары через симуляцию тысяч виртуальных свиданий.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8 max-w-7xl mx-auto">
          {steps.map((step, index) => (
            <div key={step.id} className="relative">
              {index < steps.length - 1 && (
                <div className="hidden lg:block absolute top-16 left-full w-full h-0.5 bg-gradient-to-r from-primary to-accent -translate-x-1/2 z-0" />
              )}
              
              <div className="relative bg-card rounded-2xl p-8 border border-border hover:border-primary transition-all duration-300 hover:shadow-xl z-10">
                <div className="flex items-center justify-between mb-6">
                  <div className="w-16 h-16 rounded-full bg-primary/10 flex items-center justify-center">
                    <Icon name={step.icon as any} size={32} color="var(--color-primary)" />
                  </div>
                  <div className="text-4xl font-bold text-primary/20">
                    {String(index + 1).padStart(2, '0')}
                  </div>
                </div>

                <h3 className="text-xl font-bold text-foreground mb-3">{step.title}</h3>
                <p className="text-secondary mb-4 leading-relaxed">{step.description}</p>

                <div className="flex items-center gap-2 text-sm text-primary font-medium">
                  <Icon name="Clock" size={16} />
                  <span>{step.duration}</span>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-16 text-center">
          <div className="inline-flex items-center gap-3 px-6 py-4 bg-success/10 rounded-xl border border-success/20">
            <Icon name="CheckCircle2" size={24} color="var(--color-success)" />
            <div className="text-left">
              <div className="text-sm text-secondary">Результат работы цифрового двойника</div>
              <div className="text-xl font-bold text-success">
                Лучшие совпадения из тысяч виртуальных свиданий
              </div>
            </div>
          </div>
        </div>

        <div className="mt-12 flex justify-center">
          <Button
            size="lg"
            iconName="ArrowRight"
            iconPosition="right"
            onClick={handleTestClick}
            className="text-base font-semibold"
          >
            Начать с бесплатного теста
          </Button>
        </div>
      </div>
    </section>
  );
};

export default ProcessSection;